import { motion, AnimatePresence, useReducedMotion } from "framer-motion";
import { Plus, Minus } from "lucide-react";

/**
 * Su smartphone: blocco chiuso con riga tappabile (+/−). Da 640px in su: sempre aperto, riga nascosta.
 * Il contenuto resta nel DOM su desktop; su mobile viene montato solo se aperto.
 */
export default function MobileAccordion({ id, title, open, onToggle, children }) {
  const reduce = useReducedMotion();
  const anim = reduce ? { duration: 0 } : { duration: 0.35, ease: [0.16, 1, 0.3, 1] };
  return (
    <div data-testid={`accordion-${id}`} className="mt-4 border-t border-[#2A241F] sm:mt-0 sm:border-0">
      <button
        type="button"
        data-testid={`accordion-${id}-toggle`}
        aria-expanded={open}
        aria-controls={`accordion-${id}-panel`}
        onClick={onToggle}
        className="flex min-h-[56px] w-full items-center justify-between gap-4 py-3 text-left sm:hidden"
      >
        <span className="font-heading text-lg font-black uppercase text-[#FAF7F2]">{title}</span>
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full border border-[#383029] text-[#E05A2C]">
          {open ? <Minus className="h-5 w-5" aria-hidden /> : <Plus className="h-5 w-5" aria-hidden />}
        </span>
      </button>
      <div className="hidden sm:block">{children}</div>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            id={`accordion-${id}-panel`}
            key="panel"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={anim}
            className="overflow-hidden sm:hidden"
          >
            <div className="pb-6">{children}</div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
